const TriggerEventMessage = () => {
  return (
    <>
      By using this feature, you can replicate the actions of this message within a triggered campaign. The latest event
      of this category for this profile will be used to replace the {'{{triggerEvent.*}}'} merge tags. This also
      provides context for the <i>Products from trigger event</i> algorithm, if relevant.
    </>
  );
};
export default TriggerEventMessage;
